<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @最后编辑: Betway
 * @最后修改时间: 2022-09-16 17:30:14
-->
<template>
  <div class="d-flex">
    <v-card class="mr-2">
      <div style="position: relative; height: 100%" class="d-flex flex-column">
        <div style="width: 240px; flex: 1; overflow: auto">
          <v-treeview
            dense
            ref="treeview"
            return-object
            @update:active="updateActive"
            activatable
            :active.sync="activeArr"
            :items="doc_tree"
            color="#0f46c1"
            item-key="uuid"
          >
            <template v-slot:label="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <span>
                      {{ INT(item.directory_name) }}
                    </span>
                    <span class="ml-1">({{ item.count }})</span>
                  </span>
                </template>
                <span>
                  {{ INT(item.directory_name) }}
                </span>
                <span class="ml-1">({{ item.count }})</span>
              </v-tooltip>
            </template>

            <template v-slot:append="{ open, item }">
              <menu-list :list="menulistfolder" @handleClick="handleClick($event, item)">
                <template v-slot:showAction>
                  <v-icon v-btnAuth="['delete-folder', 'rename-folder', 'move-folder']">
                    mdi-dots-vertical
                  </v-icon>
                </template>
              </menu-list>
            </template>
          </v-treeview>
        </div>
        <v-divider class="mx-4"></v-divider>
        <div
          style="height: 52px"
          class="d-flex justify-center align-center"
          v-if="hasBtn('add-folder')"
        >
          <v-btn rounded @click="CreateNewFolder" depressed color="primary" text>
            <!-- <v-icon class="material-icons">
              mdi-note-plus
            </v-icon> -->
            <img
              src="@/assets/img/create_new_folder.png"
              style="object-fit: scale-down"
              class="mr-3 text-capitalize"
              width="20"
              alt=""
            />
            {{ $t("label_create_a_new_folder") }}
          </v-btn>
        </div>
      </div>
    </v-card>
    <mrc_ess_table
      draggable
      :headers="headers"
      :append-items="
        CurrentFolder && CurrentFolder.children
          ? CurrentFolder.children.length > 0
          : false
      "
      :draggableStatus="false"
      v-model="selected"
      show-select
      :hideAddBtn="true"
      style="width: 100%"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :headerName="['document_name']"
      :slotKey="['document_name', 'date', 'created_utc_datetime', 'document_size']"
      :items="desserts"
      @move="onMove"
    >
      <template v-slot:btns>
        <v-btn
          fab
          v-if="hasBtn('move-top-doc') && selected.length == 1"
          depressed
          class="mr-2"
          height="40"
          width="40"
          @click="onMoveTop(1)"
          color="primary"
        >
          <v-icon class="material-icons">move_up</v-icon>
        </v-btn>
        <v-btn
          fab
          v-if="hasBtn('move-down-doc') && selected.length == 1"
          depressed
          class="mr-2"
          height="40"
          width="40"
          @click="onMoveTop()"
          color="primary"
        >
          <v-icon class="material-icons">move_down</v-icon>
        </v-btn>
        <v-btn
          fab
          v-if="hasBtn('upload-doc')"
          depressed
          height="40"
          width="40"
          @click="uploadingClick"
          color="primary"
        >
          <!-- <v-icon class="material-icons">
            mdi-upload
          </v-icon> -->
          <img
            src="@/assets/img/buttons.png"
            style="object-fit: scale-down"
            width="50"
            alt=""
          />
        </v-btn>
      </template>

      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>

      <template v-slot:header.document_name="{ item }">
        <span v-if="selected.length <= 0">{{ $t("label_file_name") }}</span>
        <div v-else class="d-flex align-center">
          <div
            class="px-3"
            style="border-right: 1px solid rgba(155, 153, 153, 0.3); white-space: nowrap"
          >
            {{ $t("label_selected item") }} ({{ selected.length }})
          </div>
          <div>
            <v-btn
              text
              v-if="hasBtn('download-doc')"
              @click="batch_download"
              :loading="download_loading"
              color="primary"
              rounded
              depressed
              height="40"
            >
              <!-- <v-icon class="material-icons mr-3 primary--text">
                mdi-download
              </v-icon> -->
              <img
                src="@/assets/img/download.png"
                style="object-fit: scale-down"
                class="mr-3"
                width="20"
                alt=""
              />
              <span style="color: rgb(0, 0, 0, 0.78)">
                {{ $t("label_001-018_001-017-003_lable_download") }}
              </span>
            </v-btn>
          </div>
          <div>
            <v-btn
              text
              v-if="hasBtn('move-doc')"
              color="primary"
              rounded
              @click="batch_move"
              depressed
              height="40"
            >
              <!-- <v-icon class="material-icons mr-3  primary--text">
                mdi-application-export
              </v-icon> -->
              <img
                src="@/assets/img/Vector.png"
                style="object-fit: scale-down"
                class="mr-3"
                width="20"
                alt=""
              />
              <span style="color: rgb(0, 0, 0, 0.78)">
                {{ $t("label_001-018_001-017-003_move_to_key") }}
              </span>
            </v-btn>
          </div>
          <div>
            <v-btn
              text
              v-if="hasBtn('delete-doc')"
              color="primary"
              rounded
              @click="batch_delete"
              depressed
              height="40"
            >
              <v-icon style="font-size: 22px" class="material-icons mr-3 primary--text">
                delete
              </v-icon>
              <span style="color: rgb(0, 0, 0, 0.78)">
                {{ $t("label_delete") }}
              </span>
            </v-btn>
          </div>
        </div>
      </template>

      <template v-slot:body.prepend>
        <draggable
          :list="CurrentFolder.children"
          @change="onMoveDocument"
          draggable=".dragdoc"
          tag="tbody"
          item-key="uuid"
          v-bind="{ animation: 500 }"
        >
          <tr
            v-for="(kitem, index) in CurrentFolder.children"
            :key="`documents---${index}`"
            class="dragdoc"
          >
            <td>
              <span class="d-flex flex-row flex-nowrap align-center">
                <v-icon
                  class="grey--text ml-n5"
                  :style="{
                    cursor: 'grab',
                    fontSize: '18px',
                  }"
                >
                  drag_indicator
                </v-icon>
              </span>
            </td>
            <td style="white-space: nowrap">
              <!-- style="cursor: pointer;" -->
              <span @click="clickFolder(kitem)">
                <v-icon class="material-icons">folder</v-icon>
                {{ INT(kitem.directory_name) }}
              </span>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <menu-list :list="menulistfolder" @handleClick="handleClick($event, kitem)">
                <template v-slot:showAction>
                  <v-icon v-btnAuth="['delete-folder', 'rename-folder', 'move-folder']">
                    mdi-dots-vertical
                  </v-icon>
                </template>
              </menu-list>
            </td>
          </tr>
          <tr>
            <!-- <v-divider></v-divider> -->
          </tr>
        </draggable>
      </template>

      <template v-slot:item.document_name="{ item }">
        <!-- <span v-if="item.type=='folder'">
          <v-icon class="material-icons">
            folder
          </v-icon>
          {{ INT(item.directory_name)  }}
        </span> -->
        <span>
          {{ INT(item.document_name) }}
        </span>
      </template>

      <template v-slot:item.date="{ item }">
        {{ item.created_utc_datetime | changeDate() }}
      </template>

      <template v-slot:item.created_utc_datetime="{ item }">
        {{ item.created_utc_datetime | changeDate("YYYY/MM/DD HH:mm:ss") }}
      </template>

      <template v-slot:item.document_size="{ item }">
        <span v-if="item.type != 'folder'">
          {{ (Number(item.document_size) / 1024).toFixed(2) }}KB
        </span>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <!-- v-btnAuth="[
                'view-serial-number',
                'edit-serial-number',
                'delete-serial-number',
              ]" -->
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'upload-doc',
                'move-doc',
                'eidt-doc',
                'download-doc',
                'delete-doc',
              ]"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <!-- 新增文件夹 -->
    <mrc_ess_myDialog
      v-model="dialog"
      v-if="dialog"
      :title="$t('label_new_folder')"
      width="480"
      @success="NewFolderSuccess"
      @cancel="NewFolderCancel"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" sm="12">
            <mrc_ess_multiText
              :label="$t('label_folder_name') + '*'"
              v-if="dialog"
              :isNational="judegNational('directory_name')"
              :error-messages="$errors('NewFolderForm', 'directory_name', requiredRule)"
              v-model="NewFolderForm.directory_name"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12">
            <!--  :error-messages="
                $errors('NewFolderForm', 'tricode_parent', requiredRule.concat(nocharacter))
              " 
               :isNational="
                judegNational('NewFolderForm', 'tricode_parent')
              "-->
            <tricodeParent
              :label="$t('label_parent_folder')"
              v-model="NewFolderForm.tricode_parent"
              :readonly="readonly"
            ></tricodeParent>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>
    <!-- 重命名 -->
    <mrc_ess_myDialog
      v-model="dialogRename"
      :title="edit_doc ? $t('label_Edit') : $t('label_rename')"
      width="480"
      @success="renameFolderSuccess"
      @cancel="renameFolderCancel"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" sm="12" v-if="dialogRename && !edit_doc">
            <!-- 文件夹名字 -->
            <mrc_ess_multiText
              :label="$t('label_folder_name') + '*'"
              :isNational="judegNational('directory_name')"
              :error-messages="$errors('renameFolderForm', 'reName', requiredRule)"
              v-model="renameFolderForm.reName"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12" v-if="dialogRename && edit_doc">
            <!-- 文件名字 -->
            <mrc_ess_input
              :label="$t('label_file_name') + '*'"
              :error-messages="$errors('renameFolderForm', 'reName', requiredRule)"
              v-model="renameFolderForm.reName"
            ></mrc_ess_input>
          </v-col>
          <v-col cols="12" sm="12">
            <mrc_ess_chooseStaff
              v-if="dialogRename && edit_doc"
              :label="$t('label_view_permissions')"
              v-model="renameFolderForm.permission_staff_uuid"
            ></mrc_ess_chooseStaff>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>
    <!--上传文件 -->
    <mrc_ess_myDialog
      v-model="dialogupload"
      v-if="dialogupload"
      width="600"
      :title="$t('label_upload_file')"
      @success="uploadFolderSuccess"
      @cancel="uploadFolderCancel"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" sm="12">
            <mrc_ess_bulkFile
              multiple
              :uploading="uploading"
              class="mb-4"
              @changeFile="changeFile"
            ></mrc_ess_bulkFile>
            <div
              v-for="(item, index) in uploadFolderForm.file"
              :key="index"
              class="mb-4"
              style="position: relative"
            >
              <mrc_ess_svgIcon
                :iconClass="'filetype-' + suffix(item.name)"
                style="font-size: 23px"
              />
              <span class="mx-2">{{ item.name }}</span>
              <span>({{ (item.size / 1024).toFixed(2) }}KB)</span>
              <v-icon
                class="material-icons"
                @click="deleteviewfile(item, index)"
                style="font-size: 28px; position: absolute; right: 5px"
              >
                delete
              </v-icon>
            </div>
          </v-col>
          <v-col cols="12" sm="12">
            <tricodeParent
              :label="$t('label_parent_folder') + '*'"
              :error-messages="
                $errors('uploadFolderForm', 'directory_uuid', requiredRule)
              "
              itemValue="uuid"
              v-model="uploadFolderForm.directory_uuid"
              :readonly="readonly"
            ></tricodeParent>
          </v-col>
          <v-col cols="12" sm="12">
            <mrc_ess_chooseStaff
              :label="$t('label_view_permissions')"
              v-model="uploadFolderForm.permission_staff_uuid"
              :readonly="readonly"
            ></mrc_ess_chooseStaff>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>
    <!-- 移动文件或者文件夹 -->
    <mrc_ess_myDialog
      v-model="dialogMove"
      :title="$t('label_001-018_001-017-003_move_to_key')"
      width="480"
      @success="MoveFolderSuccess"
      @cancel="MoveFolderCancel"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" sm="12">
            <tricodeParent
              :label="$t('label_destination_folder') + '*'"
              :filters="move_folder ? MoveFolderForm.uuid : ''"
              :error-messages="$errors('MoveFolderForm', 'directory_uuid', requiredRule)"
              v-if="dialogMove"
              :itemValue="move_folder ? 'tricode' : 'uuid'"
              v-model="MoveFolderForm.directory_uuid"
            ></tricodeParent>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { findSrc } from "@/service/api/upload.js";
import draggable, { filter } from "vuedraggable";
import {
  doc_tree,
  doc_add,
  doc_info,
  doc_list,
  doc_rename,
  doc_update_move,
  doc_delete,
  doc_upload,
  doc_delete_file,
  doc_move,
  doc_download,
  doc_update_name,
} from "@/service/api/directory_management.js";
import tricodeParent from "./module/tricode_parent.vue";
export default {
  components: { tricodeParent, draggable },
  props: {},
  data() {
    return {
      save_item: null,
      readonly: false,
      showMenu: false,
      dialog: false,
      dialogRename: false,
      dialogupload: false,
      dialogMove: false,
      more_status: false,
      move_folder: false,
      download_loading: false, //下载按钮加载状态
      edit_doc: false,
      clickFolder_status: false,
      selected: [],
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      uploading: false, //文档上传状态
      loading: false,
      desserts: [
        // { uuid: 'a' }, { uuid: 'c' }, { uuid: 'b' }
      ],
      activeArr: [],
      openArr: [],
      doc_tree: [],
      NewFolderForm: {
        //新增文件夹
        directory_name: "",
        tricode_parent: "",
      },
      renameFolderForm: {
        //重命名文件夹
        reName: "",
        // document_name: "",
        // directory_name: "",
        permission_staff_uuid: "",
        document_type: "",
        uuid: "",
      },
      uploadFolderForm: {
        //上传
        file: [],
        directory_uuid: "",
        permission_staff_uuid: "",
      },
      MoveFolderForm: {
        //移动
        uuid: "",
        directory_uuid: "",
      },
      fileuuids: [], //上传文件得uuid集合
      CurrentFolder: {},
    };
  },
  validations: {
    uploadFolderForm: {
      directory_uuid: {
        required,
      },
    },
    NewFolderForm: {
      directory_name: {
        required,
      },
    },
    renameFolderForm: {
      reName: {
        required,
      },
    },
    MoveFolderForm: {
      directory_uuid: {
        required,
      },
    },
  },
  computed: {
    // activeArr () {
    //   return [this.CurrentFolder.uuid]
    // },
    menulistfolder() {
      return [
        {
          name: this.$t("label_rename"),
          show: this.hasBtn("rename-folder"),
          // show: true,
          type: "rename",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-folder"),
          // show: true,
          type: "delete-folder",
        },
        {
          name: this.$t("label_001-018_001-017-003_move_to_key"), //移动
          show: this.hasBtn("move-folder"),
          // show: true,
          type: "move-folder",
        },
      ];
    },
    menulist() {
      return [
        {
          name: this.$t("label_001-018_001-017-003_lable_download"),
          show: this.hasBtn("download-doc"),
          // show: true,
          type: "download",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("eidt-doc"),
          // show: true,
          type: "edit",
        },
        {
          name: this.$t("label_001-018_001-017-003_move_to_key"),
          show: this.hasBtn("move-doc"),
          // show: true,
          type: "move",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-doc"),
          // show: true,
          type: "del",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("label_file_name"),
          align: "start",
          value: "document_name",
          sortable: false,
          header: "document_name",
        },
        {
          text: this.$t("label_time"),
          value: "date",
          sortable: false,
          align: "start",
          // header: 'date'
        },
        {
          text: this.$t("label_upload_time"),
          value: "created_utc_datetime",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_size"),
          value: "document_size",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ];
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    this.national("ess_doc_directory", "national_fields");
    await this.getBtnPermissionList();
    this.$route.meta.title = "label_document_management";
    this.$store.commit("set_page_title", "label_document_management");
    // this.national("ess_doc_org_document", "national_fields1")
    // this.national("ess_doc_directory")
  },
  watch: {
    $route(v) {
      if (v.name == "serial-number") {
        this.getlist();
      }
    },
  },
  async mounted() {
    this.getTree();
    // await this.getlist()
  },
  beforeDestroy() {},
  methods: {
    onMoveTop(sequence = undefined) {
      doc_move({
        directory_uuid: this.return_key(this.selected, "directory_uuid"),
        uuid: this.return_key(this.selected, "uuid"),
        sequence: sequence,
      }).then((res) => {
        if (res.code == 200) {
          this.selected = [];
          this.getlist();
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
        }
      });
    },
    onMove(obj, sequence) {
      doc_move({
        directory_uuid: obj.directory_uuid,
        uuid: obj.uuid,
        sequence: sequence,
      }).then((res) => {
        if (res.code == 200) {
          this.selected = [];
          this.getlist();
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
        }
      });
    },
    onMoveDocument(evt) {
      let index = evt.moved.newIndex + 1;
      var obj = evt.moved.element;
      var sequence = undefined;
      if (this.CurrentFolder.children[index]) {
        sequence = this.CurrentFolder.children[index]["sequence"];
      } else if (this.CurrentFolder.children[index - 2]) {
        sequence = this.CurrentFolder.children[index - 2]["sequence"];
      }

      if (obj && sequence !== undefined)
        doc_update_move({
          tricode_parent: obj.tricode_parent,
          directory_name: obj.directory_name,
          uuid: obj.uuid,
          sequence: sequence,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getTree();
            this.getlist(null, true);
            // this.CurrentFolder.children = this.CurrentFolder.children.map((item, index) => {
            //   return Object.assign({}, item, {
            //     sequence: index + 1
            //   })
            // })
            // this.CurrentFolder = {}
            // this.updateActive(this.save_item)
          }
        });
    },
    updateAll() {
      this.$refs.treeview.updateAll(true);
    },
    CreateNewFolder() {
      this.dialog = true;
      this.$v.NewFolderForm.$reset();
    },
    uploadingClick() {
      this.dialogupload = true;
      this.$v.uploadFolderForm.$reset();
    },
    suffix(val) {
      return val.slice(val.indexOf(".") + 1);
    },
    changeFile(val) {
      this.uploading = true;
      let fns = [];
      //Can't use forEach with Filelist
      Array.from(val).forEach((item, index) => {
        fns.push(
          new Promise((resolve, reject) => {
            this.$uploadFiles([item], {
              module_uuid: "companydoc",
            }).then((res) => {
              if (typeof res == "object" && res != undefined && res.code == 200) {
                resolve();
                this.fileuuids.push(res.uuid);
                this.uploadFolderForm.file.push({
                  uuid: res.uuid,
                  path: res.url,
                  name: item.name,
                  size: item.size,
                  type: item.type,
                });
              } else {
                reject();
              }
            });
          })
        );
      });
      Promise.all(fns)
        .then((res) => {
          this.uploading = false;
        })
        .catch((err) => {
          this.uploading = false;
        });
    },
    deleteviewfile(val, index) {
      this.uploadFolderForm.file.splice(index, 1);
      this.fileuuids.splice(index, 1);
      this.$deleteFile(val.uuid);
    },
    async getTree() {
      doc_tree().then((res) => {
        if (res.code == 200) {
          this.doc_tree = res.data;
        }
      });
    },
    updateActive(item) {
      // console.log('updateActive');
      this.selected = [];
      if (this.clickFolder_status) {
        this.clickFolder_status = false;
        this.getlist();
        return;
      }
      if (item.length <= 0) {
        this.desserts = [];
        this.CurrentFolder = {};
        return;
      }
      this.save_item = item;
      this.CurrentFolder = item[0];
      // this.activeArr = [item[0].uuid]
      this.getlist();
    },
    clickFolder(item) {
      this.clickFolder_status = true;
      this.CurrentFolder = item;
      this.activeArr = [item];
      this.updateAll();
      this.getlist();
    },
    async getlist(obj, refresh_doc = false) {
      if (!refresh_doc) this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const res = await doc_list({
        directory_uuid: this.CurrentFolder.uuid,
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
        if (refresh_doc) {
          this.CurrentFolder.children = [];
          this.CurrentFolder.children = res.ess_doc_directory
            ? res.ess_doc_directory
            : [];
        }
      }
      this.loading = false;
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.dialogRename = true;
          this.edit_doc = true;
          this.$set(this.renameFolderForm, "uuid", obj.uuid);
          this.$set(this.renameFolderForm, "reName", this.$clone(obj.document_name));
          this.$set(
            this.renameFolderForm,
            "document_type",
            this.$clone(obj.document_type)
          );
          this.$set(
            this.renameFolderForm,
            "permission_staff_uuid",
            this.$clone(obj.permission_staff_uuid)
          );
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            doc_delete_file({
              uuid: obj.uuid,
              file_name: obj.document_name,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1) this.options.cpage--;
                this.getTree();
                this.getlist();
              }
            });
          });
          break;
        case "rename":
          this.dialogRename = true;
          this.edit_doc = false;
          this.$set(this.renameFolderForm, "uuid", obj.uuid);
          this.$set(this.renameFolderForm, "reName", this.$clone(obj.directory_name));
          break;
        case "delete-folder":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            doc_delete({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.CurrentFolder = {};
                this.desserts = [];
                this.$Message({
                  text: this.$t("message_The_operation_was_successful"),
                });
                this.getTree();
              }
            });
          });
          break;
        case "move": //移动文件
          this.dialogMove = true;
          this.MoveFolderForm.uuid = obj.uuid;
          this.$v.MoveFolderForm.$reset();
          break;
        case "move-folder": //移动文件夹
          this.dialogMove = true;
          this.move_folder = true;
          this.MoveFolderForm.uuid = obj.uuid;
          this.MoveFolderForm.directory_name = obj.directory_name;
          this.$v.MoveFolderForm.$reset();
          break;
        case "download":
          //
          this.$singleDownload(obj.attachment_uuid, obj.document_name, obj.document_type);
          doc_download({
            // attachment_uuid: obj.directory_uuid,
            file_name: obj.document_name,
            uuid: obj.uuid,
          });
          break;
      }
    },
    NewFolderSuccess() {
      this.$v.NewFolderForm.$touch();
      if (this.$v.NewFolderForm.$error) return;
      doc_add({
        directory_name: this.NewFolderForm.directory_name,
        org_level_uuid: this.$store.state.currentCompany,
        tricode_parent: this.NewFolderForm.tricode_parent,
      }).then((res) => {
        if (res.code == 200) {
          this.NewFolderForm = {
            directory_name: "",
            tricode_parent: "",
          };
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          this.getTree();
        }
      });
      this.dialog = false;
    },
    NewFolderCancel() {
      this.NewFolderForm = {
        directory_name: "",
        tricode_parent: "",
      };
    },
    renameFolderSuccess() {
      this.$v.renameFolderForm.$touch();
      if (this.$v.renameFolderForm.$error) return;
      if (this.edit_doc) {
        //文档修改
        doc_rename({
          uuid: this.renameFolderForm.uuid,
          document_name: this.renameFolderForm.reName,
          // +
          // "." +
          // this.renameFolderForm.document_type,
          permission_staff_uuid: this.renameFolderForm.permission_staff_uuid,
        }).then((res) => {
          if (res.code == 200) {
            this.renameFolderForm = {
              uuid: "",
              reName: "",
              document_type: "",
              permission_staff_uuid: "",
            };
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getlist();
          }
        });
      } else {
        //文件夹修改
        doc_update_name({
          uuid: this.renameFolderForm.uuid,
          directory_name: this.renameFolderForm.reName,
        }).then((res) => {
          if (res.code == 200) {
            this.CurrentFolder.directory_name = this.renameFolderForm.reName;
            this.renameFolderForm = {
              uuid: "",
              reName: "",
            };
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getTree();
          }
        });
      }
      this.edit_doc = false;
      this.dialogRename = false;
    },
    renameFolderCancel() {
      this.renameFolderForm = {
        uuid: "",
        reName: "",
        document_type: "",
        permission_staff_uuid: "",
      };
    },
    uploadFolderSuccess() {
      if (this.uploading) {
        return this.$Message({
          // text: this.$t('文件正在上传，请勿提交'),
          text: this.$t("verify_file_is_being_uploaded_do_not_submit"),
          color: "rgb(0,0,0,0.78)",
        });
      }
      this.$v.uploadFolderForm.$touch();
      if (this.$v.uploadFolderForm.$error) return;
      if (!this.fileuuids.join()) {
        return this.$Message({
          // text: this.$t('上传文件不能为空'),
          text: this.$t("verify_the_uploaded_file_cannot_be_empty"),
          color: "rgb(0,0,0,0.78)",
        });
      }
      doc_upload({
        attachment_uuid: this.fileuuids.join(),
        directory_uuid: this.uploadFolderForm.directory_uuid,
        permission_staff_uuid: this.uploadFolderForm.permission_staff_uuid,
      }).then((res) => {
        if (res.code == 200) {
          this.getTree();
          this.getlist();
          this.fileuuids = [];
          this.uploadFolderForm.file = [];
          this.uploadFolderForm = {
            file: [],
            directory_uuid: "",
            permission_staff_uuid: "",
          };
          this.$Message({
            text: this.$t("message_The_upload_was_successful"),
          });
        }
      });
      this.dialogupload = false;
    },
    uploadFolderCancel() {
      this.fileuuids = [];
      this.uploadFolderForm.file = [];
      this.uploadFolderForm = {
        file: [],
        directory_uuid: "",
        permission_staff_uuid: "",
      };
    },
    MoveFolderSuccess() {
      this.$v.MoveFolderForm.$touch();
      if (this.$v.MoveFolderForm.$error) return;
      if (this.more_status) {
        //多选 文件移动
        // if (this.selected.length <= 0) {
        //   return this.$Message({
        //     text: this.$t('选择文件不能为空'),
        //     color: 'rgb(0,0,0,0.78)'
        //   })
        // }
        doc_move({
          directory_uuid: this.MoveFolderForm.directory_uuid,
          uuid: this.return_key(this.selected, "uuid"),
        }).then((res) => {
          if (res.code == 200) {
            this.getTree();
            this.getlist();
            this.selected = [];
            this.MoveFolderForm = {
              uuid: "",
              directory_uuid: "",
            };
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
          }
        });
      } else if (this.move_folder) {
        //文件夹移动
        doc_update_move({
          uuid: this.MoveFolderForm.uuid,
          directory_name: this.MoveFolderForm.directory_name,
          tricode_parent: this.MoveFolderForm.directory_uuid,
        }).then((res) => {
          if (res.code == 200) {
            this.MoveFolderForm = {
              uuid: "",
              directory_name: "",
            };
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getTree();
          }
        });
      } else {
        //单选 文件移动
        doc_move({
          directory_uuid: this.MoveFolderForm.directory_uuid,
          uuid: this.MoveFolderForm.uuid,
        }).then((res) => {
          if (res.code == 200) {
            this.getlist();
            this.getTree();
            this.MoveFolderForm = {
              uuid: "",
              directory_uuid: "",
            };
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
          }
        });
      }
      this.move_folder = false;
      this.dialogMove = false;
      this.more_status = false;
    },
    MoveFolderCancel() {
      this.MoveFolderForm = {
        uuid: "",
        directory_uuid: "",
      };
    },
    batch_move() {
      this.dialogMove = true;
      this.more_status = true;
      this.$v.MoveFolderForm.$reset();
    },
    async batch_download() {
      this.download_loading = true;
      // findSrc()
      let arr = []; // 文件内容，地址，名称等等组成的数组对象
      let fns = []; //Promise对象集合
      this.selected.forEach((item) => {
        fns.push(
          new Promise((resolve, reject) => {
            findSrc({ uuid: item.attachment_uuid }).then((res) => {
              if (res.code == 200) {
                // console.log(res, 'res');
                resolve(
                  arr.push({
                    ...res.data.files[0],
                    file_name: item.document_name,
                  })
                );
              } else {
                reject();
              }
            });
          })
        );
      });
      Promise.all(fns)
        .then((result) => {
          this.$batchDownload(arr)
            .then((res) => {
              // console.log(res, '正确');
              this.download_loading = false;
              doc_download({
                file_name: this.return_key(this.selected, "document_name"),
                uuid: this.return_key(this.selected, "uuid"),
              });
              this.selected = [];
            })
            .catch((err) => {
              this.download_loading = false;
              this.$Message({
                text: this.$t("error_DOWNLOAD_FAIL"),
                color: "rgb(0,0,0,0.78)",
              });
            });
        })
        .catch((error) => {
          this.download_loading = false;
          this.$Message({
            text: this.$t("error_DOWNLOAD_FAIL"),
            color: "rgb(0,0,0,0.78)",
          });
        });
    },
    batch_delete() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        doc_delete_file({
          uuid: this.return_key(this.selected, "uuid"),
          file_name: this.return_key(this.selected, "document_name"),
        }).then((res) => {
          if (res.code == 200) {
            this.selected = [];
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            if (this.desserts.length == 1) this.options.cpage--;
            this.getTree();
            this.getlist();
          }
        });
      });
    },
    return_key(arr, key) {
      let a = [];
      arr.forEach((item) => {
        a.push(item[key]);
      });
      return a.join();
    },
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}

.tableBoxComponent /deep/ .v-simple-checkbox .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.tableBoxComponent /deep/ .v-simple-checkbox .mdi-checkbox-marked {
  color: #0f46c1 !important;
}

.tableBoxComponent /deep/ .v-simple-checkbox .mdi-minus-box {
  color: #0f46c1 !important;
}

/* .v-treeview-node__root {
  background: red;
} */
</style>
